export default __webpack_public_path__ + "static/media/kuulolaitehuolto-white.77886d9a.svg";